import React from "react";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import locoIcon from "../../../images/gameplay_ui/icons/bottom_panel/credit.svg"
import AddRemoveButtons from "../AddRemoveButtons";
import GameButtonWithText from "../GameButtonWithText";
import GameData from "../../../gameplay/model/GameData";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import x from "../../../images/icons/close_red.svg";

class CreditPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: GameData.CurrentGame.credit,
      initialCount: GameData.CurrentGame.credit,
    }

    let economyIndex = UtilsFunctions.getRoleNameIndex("Зам. по экономике и финансам");
    this.isFinanceDirector = UtilsFunctions.playerHasRole(economyIndex);
  }

  componentDidMount() {
    this.setState({
      count: GameData.CurrentGame.credit
    });
    this.cashWouldBe = GameData.CurrentGame.cash;
  }

  addBrigades(diff) {
    this.cashWouldBe -= this.state.count > diff ? 1000000 : -1000000;
    this.setState({
      count: Number(diff)
    });
  }

  isNormalInteger(str) {
    let n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  }

  render() {
    let bgStyle = {
      zIndex: "10",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      width: "184px",
      height: "150px",
      padding: "5px",
      borderRadius: "3px",
      background: "#F2F2F2"
    }
    let posStyle = this.props.isRight ? {left: "10px"} : {right: "10px"};

    return <div style={{...bgStyle, ...posStyle}}>
      <CurrencyCard icon={locoIcon} value={"Кредит"} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <img src={x} alt="X" className="x" onClick={() => {
        this.props.onClose(this)
      }}/>
      <div className="input" style={{position: "relative"}}>
        <div>
          <input
            className={"popup-input"}
            style={{
              position: "absolute",
              bottom: "0",
              left: "calc(50% - 20px)"
            }}
            type="number"
            max={300}
            value={Math.floor(this.state.count / 1000000)}
            disabled={!this.isFinanceDirector}
            onInput={(e) => {
              let val = e.target.value;
              if (this.isNormalInteger(val)) {
                if (val > 1000) {
                  val = 1000;
                }
                this.addBrigades(val * 1000000)
              } else {
                this.addBrigades(0)
              }
            }}
          />
        </div>
        <AddRemoveButtons
          width={130}
          step={1000000}
          currentRuntime={Number(this.state.count)}
          isHideText={true}
          onValueChanged={this.addBrigades.bind(this)}
          isCanBuy={this.isFinanceDirector && this.state.count < GameData.CurrentGame.fixedAssets}
          isCanSell={this.isFinanceDirector && this.state.count > 0 && this.cashWouldBe > 0}
        />
      </div>
      <GameButtonWithText
        width={164}
        height={30}
        colorStart={"#8CED00"}
        colorEnd={"#66AE04"}
        title={"использовать"}
        disabled={!this.isFinanceDirector}
        onClick={() => {
          let val = this.state.count;

          let cash = GameData.CurrentGame.cash;
          let credit = GameData.CurrentGame.credit;

          const creditDiff = credit - this.state.count;

          if (this.state.count < credit && creditDiff > cash)
            return;

          if (this.state.count === 0) {
            val = cash > 0 ? credit - cash : 0
          }

          if (val < 0)
            return;

          agent.GamePlay.addCreditCash(
            this.props.teamID, {
              credit: val
            }, resp => {
              console.log(resp)
            });
        }}/>
    </div>
  }
}

export default CreditPopup;
